var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "h2 text-center" }, [
          _vm._v("\n      WELCOME TO TONE NETWORKS\n    ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "h5 text-center has-spaces" }, [
          _c("span", [_vm._v("SET THE TONE OF YOUR LIFE")]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "text-danger" }, [
            _vm._v("OH! I SEE YOU ARE TONE NETWORKS ADMIN SO BE CAREFUL!")
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "text-muted" }, [
            _vm._v("YOU CAN SET THE TONE OF OTHERS LIVES TOO")
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72d394fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72d394fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Home/HeroBanner.vue
// module id = 7f3L
// module chunks = 0